export const routeDashboard = () => '/dashboard'
export const routeHome = () => '/'
export const routeCampaignDetails = (addr: string) => `/campaigns/${addr}`
export const routeCreateCampaign = () => '/create'
export const routeEditCampaign = (addr: string) => `/edit/${addr}`
